
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33886',
  depVersions: {
  "documents-public-ui": "static-1.33886",
  "client-types": "static-1.444",
  "documents-lib": "static-1.33891",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1892",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4754",
  "highcharts": "static-8.99",
  "hs-promise-utils": "static-1.5359",
  "hs-test-utils": "static-1.7773",
  "hub-http": "static-1.5966",
  "hubspot-dlb": "static-2.1796",
  "HubStyleTokens": "static-2.11187",
  "I18n": "static-7.1561",
  "jasmine-immutable": "static-1.2786",
  "jasmine-runner": "static-1.6241",
  "lodash": "static-1.3",
  "quartz": "static-1.6683",
  "react": "static-7.177",
  "react-dlb": "static-1.71",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.66",
  "react-rhumb": "static-1.16408",
  "reporting-data": "static-1.66376",
  "reporting-testing-lib": "static-1.8309",
  "reporting-visualizations": "static-1.58452",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4533",
  "webpack-env": "static-1.54",
  "atom": "static-1.4838",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2253",
  "classnames": "static-2.10",
  "cssUtils": "static-1.723",
  "customer-data-filters-ui": "static-1.38762",
  "customer-data-objects": "static-1.7412",
  "customer-data-property-utils": "static-1.7839",
  "data-fetching-client": "static-1.9445",
  "enviro": "static-4.387",
  "FireAlarmUi": "static-1.4298",
  "flux-actions": "static-1.304",
  "FormsCommonComponents": "static-1.85203",
  "FormUrlGenerator": "static-2.4498",
  "foundations-components": "static-1.7459",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3917",
  "HubStyle": "static-2.11495",
  "icons": "static-2.618",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6930",
  "metrics-js": "static-1.9391",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.349",
  "property-description-translator": "static-1.3627",
  "property-translator": "static-1.5181",
  "quartz-config": "static-1.461",
  "quartz-core": "static-1.5902",
  "quick-fetch": "static-1.3703",
  "raven": "static-3.5624",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5144",
  "react-virtualized": "static-2.94",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7927",
  "reference-resolvers-lite": "static-1.7857",
  "report-customization-components": "static-1.12405",
  "reporting-enablement": "static-1.21955",
  "reporting-reports": "static-1.66054",
  "reporting-snowflake": "static-1.54994",
  "reporting-ui-components": "static-2.63647",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4399",
  "sales-content-partitioning": "static-1.8702",
  "SalesContentIndexUI": "static-3.8852",
  "sanitize": "static-1.4242",
  "sanitize-text": "static-1.7908",
  "self-service-api": "static-1.10004",
  "SharedI18nStrings": "static-1.180",
  "SharedLegalStrings": "static-1.1521",
  "signup-constants": "static-1.18321",
  "signup-ui-lego-core": "static-1.20331",
  "signup-ui-url-generator": "static-2.7831",
  "styled-components": "static-2.84",
  "StyleGuideUI": "static-3.483",
  "superstore": "static-1.4539",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10762",
  "ui-addon-i18n": "static-1.10899",
  "ui-addon-react-router-dom": "static-1.9316",
  "ui-addon-upgrades": "static-9.17601",
  "ui-asset-management-lib": "static-1.10665",
  "ui-images": "static-2.1083",
  "UIComponents": "static-3.8134",
  "usage-tracker": "static-1.7101",
  "usage-tracker-container": "static-1.7091",
  "usage-tracker-core": "static-1.6951",
  "usage-tracker-public": "static-1.6912",
  "viral-links-lib": "static-1.6796",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven-hubspot": "static-1.5931",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3195",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2960",
  "quartz-webpack": "static-1.2907",
  "ai-components-ui-library": "static-1.8258",
  "amplitude-session-replay-browser": "static-1.55",
  "foundations-assets": "static-1.4600",
  "foundations-theming": "static-1.4176",
  "quartz-auth": "static-1.358",
  "usage-tracker-session-replay": "static-1.4787",
  "foundations-theming-base": "static-1.3161",
  "HeadJS": "static-2.703",
  "framer-motion": "static-1.67",
  "hs-test-utils-bend-plugin": "static-1.2884",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4098",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7691",
  "graphql": "static-1.77",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3397",
  "persist-promise": "static-1.3475",
  "reporting-client-types": "static-1.2376",
  "hs-story-utils": "static-1.9196",
  "react-flip-move": "static-1.65",
  "hub-http-shared-msw-handlers": "static-1.9394",
  "hubspotter-http": "static-1.4448",
  "sassPrefix": "static-1.151",
  "conversations-skeleton-state": "static-1.7017",
  "crm-message-bus": "static-1.42247",
  "customer-data-filters-ui-msw-helpers": "static-1.21196",
  "customer-data-objects-ui-components": "static-1.12771",
  "customer-data-reference-ui-components": "static-1.12910",
  "customer-data-ui-utilities": "static-1.9592",
  "framework-builder-read-service-client": "static-1.3817",
  "framework-data-schema-quick-fetch": "static-1.6542",
  "framework-data-schema-resolvers": "static-1.6637",
  "inbound-db-properties-service-client": "static-1.3646",
  "multi-account-reference-resolvers": "static-1.736",
  "onboarding-tours": "static-1.16213",
  "reporting-datasets-permissions-lib": "static-1.12954",
  "ui-addon-teams": "static-1.21195",
  "apollo-stack-hubspot": "static-3.81",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67520",
  "customer-data-properties": "static-1.50688",
  "forms-ai-lib": "static-1.3964",
  "forms-utils-lib": "static-1.12108",
  "foundations-components-test-utils": "static-1.4942",
  "react-dnd-compat": "static-1.4391",
  "react-tinymce": "static-1.54528",
  "tinymce-config": "static-2.53654",
  "ui-gdpr-components": "static-1.10114",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3728",
  "floating-ui": "static-1.51",
  "react-aria": "static-1.61",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1101",
  "ui-fonts": "static-1.449",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.786",
  "mobile-manifest-mixins": "static-1.476",
  "module-federation": "static-1.18",
  "quartz-head": "static-1.348",
  "quartz-i18n": "static-1.358",
  "quartz-routing": "static-1.113",
  "quartz-test": "static-1.358",
  "batch-promise": "static-1.1318",
  "external-options-client-types": "static-1.3954",
  "react-colorpicker": "static-2.9980",
  "copilot-toolkit": "static-1.10437",
  "data-quality-ui-library": "static-1.12241",
  "html-to-image": "static-1.49",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40558",
  "reporting-insights-lib": "static-1.1061",
  "reporting-plugins": "static-1.9940",
  "ui-addon-draggable-compat": "static-2.4021",
  "ui-addon-opt": "static-4.8153",
  "ui-shepherd-react": "static-3.9912",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24627",
  "hubspot-apollo-client": "static-1.4647",
  "sales-templates-service-types-lib": "static-1.3964",
  "ui-business-units-lib": "static-1.8790",
  "merchandise-lib": "static-1.257",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5437",
  "salesImages": "static-1.520",
  "ts-schema": "static-1.3874",
  "upgrade-management-service-types": "static-1.4275",
  "timezone-utils": "static-2.5012",
  "bender-build-tools": "static-1.2903",
  "chatspot-core": "static-1.20177",
  "chirp-fetch": "static-1.1651",
  "bend-plugin-foundations-theming": "static-1.2659",
  "stylex": "static-1.27",
  "hubspotter-http-shared-msw-handlers": "static-1.9392",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3594",
  "crm-pipelines-api-client-types": "static-1.3935",
  "multi-currency-client-types": "static-1.3488",
  "getting-started-shared-tasks": "static-1.17784",
  "growth-data-modal": "static-1.5118",
  "growth-onboarding-confetti": "static-1.2838",
  "growth-onboarding-next-action-utils": "static-1.1262",
  "navigation-components": "static-1.17156",
  "onboarding-tours-client": "static-1.4427",
  "onboarding-tours-utils": "static-1.279",
  "ui-shepherd-tracker": "static-1.7293",
  "ui-universal-auth": "static-1.8646",
  "user-context": "static-1.4862",
  "cms-field-types": "static-1.4574",
  "content-icons-ui": "static-1.2144",
  "integrations-lib": "static-1.15304",
  "calling-global-api": "static-1.63538",
  "calling-internal-common": "static-1.31060",
  "calling-lifecycle-internal": "static-1.64920",
  "calling-lifecycle-messages": "static-1.57214",
  "commerce-products-lib": "static-1.8752",
  "crm-links": "static-1.6022",
  "file-manager-components": "static-1.22787",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.439",
  "inbounddb-objects-service-types": "static-1.4020",
  "meetings-icalendar-utils-lib": "static-1.402",
  "object-builder-ui-client": "static-1.47855",
  "pipeline-validation-client-types": "static-1.3757",
  "property-value-citations": "static-1.1302",
  "pulse": "static-1.271",
  "smart-property-lib": "static-1.5753",
  "tiered-pricing": "static-1.780",
  "ui-addon-iframeable": "static-1.8809",
  "final-form": "static-1.65",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19417",
  "tinymce-themes": "static-1.55624",
  "data-token-picker": "static-1.15990",
  "hub-http-contrib": "static-1.2812",
  "interframe": "static-3.4559",
  "tinymce-data": "static-1.39739",
  "tinymce-plugins": "static-1.56768",
  "ui-addon-sales-email": "static-1.4981",
  "magpie-lib": "static-1.5362",
  "magpie-types": "static-1.4822",
  "simple-logging-lib": "static-1.2818",
  "content-assistance-lib": "static-1.7399",
  "dashboard-lib": "static-1.80474",
  "ExportDialog": "static-6.10156",
  "hubspot-prosemirror": "static-1.17507",
  "hubspot-prosemirror-plugins": "static-1.17499",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8458",
  "campaign-roi-lib": "static-1.8182",
  "feedback-loader": "static-1.28790",
  "onboarding-scopes": "static-1.6232",
  "apollo-link-hub-http": "static-2.4417",
  "hubspot-apollo-cache": "static-1.106",
  "growth-monetization-service-types": "static-1.4291",
  "nav-client-types": "static-1.2123",
  "purchase-motions-api": "static-1.5440",
  "trials-service-types": "static-1.3692",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.494",
  "getting-started-shared-tasks-store": "static-1.16902",
  "integrations-error-boundary-lib": "static-1.12719",
  "integrations-tracking-lib": "static-1.5351",
  "native-integrations-shared-strings": "static-1.7556",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10140",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31066",
  "shared-worker-versioning": "static-1.10805",
  "calling-usage-tracker": "static-1.6306",
  "voice-sms-access-library": "static-1.143",
  "customer-data-tracking": "static-1.6650",
  "products-iframe-lib": "static-1.7223",
  "products-ui-components-shared-msw-handlers": "static-1.9776",
  "location-customization-utils-lib": "static-1.8448",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3922",
  "video-components-external": "static-1.10473",
  "video-data-lib": "static-1.34131",
  "directed-graph": "static-1.705",
  "event-emitter": "static-1.715",
  "breeze-intelligence-kit": "static-1.5272",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9477",
  "fsm": "static-1.3499",
  "policy-lib": "static-1.6552",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9540",
  "navigation-messaging": "static-1.6483",
  "FileManagerLib": "static-1.38427",
  "NamespacedHubStyle": "static-2.8867",
  "FileManagerCore": "static-1.38286",
  "codemirror": "static-5.90",
  "layout-dnd-components": "static-1.11973",
  "layout-dnd-utils": "static-1.10948",
  "react-codemirror": "static-1.10394",
  "ui-addon-emoji-picker": "static-1.9657",
  "ui-brand-identity-lib": "static-1.13697",
  "ui-addon-video-player": "static-1.8463",
  "ui-coaching-tips": "static-1.27853",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8336",
  "payment-link-components": "static-1.22839",
  "EmailSignatureEditor": "static-1.23859",
  "eligibility-engine-service-types": "static-1.2973",
  "universal-page-editor-lib": "static-1.2763",
  "calling-orchestration-schema": "static-1.34920",
  "sales-views-client-types": "static-1.4059",
  "crm-record-cards-service-types": "static-1.3422",
  "content-media-composition-data-lib": "static-1.11329",
  "content-media-compositions": "static-2.15336",
  "media-bridge-lib": "static-1.18512",
  "trellis-story-utils": "static-1.4291",
  "storybook-react": "static-1.28",
  "audio-components": "static-1.5564",
  "FileManagerImages": "static-1.35938",
  "video-components": "static-1.12476",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4302",
  "video-embed": "static-1.34965",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67595",
  "layout-data-lib": "static-1.9273",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6353",
  "commerce-tours-lib": "static-1.5668",
  "growth-onboarding-reliability": "static-1.4856",
  "sales-checkout-service-client": "static-1.3445",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21255",
  "sales-email-signature-service-client": "static-1.3612",
  "hls.js": "static-1.34",
  "social-insights-client-types": "static-1.21258",
  "outpost": "static-1.3975",
  "advanced-menus-core": "static-1.14768",
  "advanced-menus-lib": "static-1.11750",
  "ui-memberships-settings-lib": "static-1.33336",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14767",
  "simple-menus-lib": "static-1.16284"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33886",
  "client-types": "/client-types/static-1.444",
  "documents-lib": "/documents-lib/static-1.33891",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1892",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4754",
  "highcharts": "/highcharts/static-8.99",
  "hs-promise-utils": "/hs-promise-utils/static-1.5359",
  "hs-test-utils": "/hs-test-utils/static-1.7773",
  "hub-http": "/hub-http/static-1.5966",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "HubStyleTokens": "/HubStyleTokens/static-2.11187",
  "I18n": "/I18n/static-7.1561",
  "jasmine-immutable": "/jasmine-immutable/static-1.2786",
  "jasmine-runner": "/jasmine-runner/static-1.6241",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6683",
  "react": "/react/static-7.177",
  "react-dlb": "/react-dlb/static-1.71",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.66",
  "react-rhumb": "/react-rhumb/static-1.16408",
  "reporting-data": "/reporting-data/static-1.66376",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8309",
  "reporting-visualizations": "/reporting-visualizations/static-1.58452",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4533",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4838",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2253",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.723",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38762",
  "customer-data-objects": "/customer-data-objects/static-1.7412",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7839",
  "data-fetching-client": "/data-fetching-client/static-1.9445",
  "enviro": "/enviro/static-4.387",
  "FireAlarmUi": "/FireAlarmUi/static-1.4298",
  "flux-actions": "/flux-actions/static-1.304",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85203",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4498",
  "foundations-components": "/foundations-components/static-1.7459",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyle": "/HubStyle/static-2.11495",
  "icons": "/icons/static-2.618",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6930",
  "metrics-js": "/metrics-js/static-1.9391",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "property-description-translator": "/property-description-translator/static-1.3627",
  "property-translator": "/property-translator/static-1.5181",
  "quartz-config": "/quartz-config/static-1.461",
  "quartz-core": "/quartz-core/static-1.5902",
  "quick-fetch": "/quick-fetch/static-1.3703",
  "raven": "/raven/static-3.5624",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5144",
  "react-virtualized": "/react-virtualized/static-2.94",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7927",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7857",
  "report-customization-components": "/report-customization-components/static-1.12405",
  "reporting-enablement": "/reporting-enablement/static-1.21955",
  "reporting-reports": "/reporting-reports/static-1.66054",
  "reporting-snowflake": "/reporting-snowflake/static-1.54994",
  "reporting-ui-components": "/reporting-ui-components/static-2.63647",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4399",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8702",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8852",
  "sanitize": "/sanitize/static-1.4242",
  "sanitize-text": "/sanitize-text/static-1.7908",
  "self-service-api": "/self-service-api/static-1.10004",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1521",
  "signup-constants": "/signup-constants/static-1.18321",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20331",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7831",
  "styled-components": "/styled-components/static-2.84",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "superstore": "/superstore/static-1.4539",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10762",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10899",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9316",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17601",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10665",
  "ui-images": "/ui-images/static-2.1083",
  "UIComponents": "/UIComponents/static-3.8134",
  "usage-tracker": "/usage-tracker/static-1.7101",
  "usage-tracker-container": "/usage-tracker-container/static-1.7091",
  "usage-tracker-core": "/usage-tracker-core/static-1.6951",
  "usage-tracker-public": "/usage-tracker-public/static-1.6912",
  "viral-links-lib": "/viral-links-lib/static-1.6796",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3195",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2960",
  "quartz-webpack": "/quartz-webpack/static-1.2907",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8258",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "foundations-assets": "/foundations-assets/static-1.4600",
  "foundations-theming": "/foundations-theming/static-1.4176",
  "quartz-auth": "/quartz-auth/static-1.358",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4787",
  "foundations-theming-base": "/foundations-theming-base/static-1.3161",
  "HeadJS": "/HeadJS/static-2.703",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2884",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4098",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7691",
  "graphql": "/graphql/static-1.77",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
  "persist-promise": "/persist-promise/static-1.3475",
  "reporting-client-types": "/reporting-client-types/static-1.2376",
  "hs-story-utils": "/hs-story-utils/static-1.9196",
  "react-flip-move": "/react-flip-move/static-1.65",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9394",
  "hubspotter-http": "/hubspotter-http/static-1.4448",
  "sassPrefix": "/sassPrefix/static-1.151",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7017",
  "crm-message-bus": "/crm-message-bus/static-1.42247",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21196",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12771",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12910",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9592",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3817",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6542",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6637",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3646",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.736",
  "onboarding-tours": "/onboarding-tours/static-1.16213",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12954",
  "ui-addon-teams": "/ui-addon-teams/static-1.21195",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.81",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67520",
  "customer-data-properties": "/customer-data-properties/static-1.50688",
  "forms-ai-lib": "/forms-ai-lib/static-1.3964",
  "forms-utils-lib": "/forms-utils-lib/static-1.12108",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4942",
  "react-dnd-compat": "/react-dnd-compat/static-1.4391",
  "react-tinymce": "/react-tinymce/static-1.54528",
  "tinymce-config": "/tinymce-config/static-2.53654",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10114",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3728",
  "floating-ui": "/floating-ui/static-1.51",
  "react-aria": "/react-aria/static-1.61",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1101",
  "ui-fonts": "/ui-fonts/static-1.449",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.786",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.476",
  "module-federation": "/module-federation/static-1.18",
  "quartz-head": "/quartz-head/static-1.348",
  "quartz-i18n": "/quartz-i18n/static-1.358",
  "quartz-routing": "/quartz-routing/static-1.113",
  "quartz-test": "/quartz-test/static-1.358",
  "batch-promise": "/batch-promise/static-1.1318",
  "external-options-client-types": "/external-options-client-types/static-1.3954",
  "react-colorpicker": "/react-colorpicker/static-2.9980",
  "copilot-toolkit": "/copilot-toolkit/static-1.10437",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12241",
  "html-to-image": "/html-to-image/static-1.49",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40558",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1061",
  "reporting-plugins": "/reporting-plugins/static-1.9940",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4021",
  "ui-addon-opt": "/ui-addon-opt/static-4.8153",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9912",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24627",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4647",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3964",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8790",
  "merchandise-lib": "/merchandise-lib/static-1.257",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5437",
  "salesImages": "/salesImages/static-1.520",
  "ts-schema": "/ts-schema/static-1.3874",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4275",
  "timezone-utils": "/timezone-utils/static-2.5012",
  "bender-build-tools": "/bender-build-tools/static-1.2903",
  "chatspot-core": "/chatspot-core/static-1.20177",
  "chirp-fetch": "/chirp-fetch/static-1.1651",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2659",
  "stylex": "/stylex/static-1.27",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9392",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3594",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3935",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3488",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17784",
  "growth-data-modal": "/growth-data-modal/static-1.5118",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2838",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1262",
  "navigation-components": "/navigation-components/static-1.17156",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4427",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.279",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7293",
  "ui-universal-auth": "/ui-universal-auth/static-1.8646",
  "user-context": "/user-context/static-1.4862",
  "cms-field-types": "/cms-field-types/static-1.4574",
  "content-icons-ui": "/content-icons-ui/static-1.2144",
  "integrations-lib": "/integrations-lib/static-1.15304",
  "calling-global-api": "/calling-global-api/static-1.63538",
  "calling-internal-common": "/calling-internal-common/static-1.31060",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64920",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57214",
  "commerce-products-lib": "/commerce-products-lib/static-1.8752",
  "crm-links": "/crm-links/static-1.6022",
  "file-manager-components": "/file-manager-components/static-1.22787",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.439",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4020",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.402",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47855",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3757",
  "property-value-citations": "/property-value-citations/static-1.1302",
  "pulse": "/pulse/static-1.271",
  "smart-property-lib": "/smart-property-lib/static-1.5753",
  "tiered-pricing": "/tiered-pricing/static-1.780",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8809",
  "final-form": "/final-form/static-1.65",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19417",
  "tinymce-themes": "/tinymce-themes/static-1.55624",
  "data-token-picker": "/data-token-picker/static-1.15990",
  "hub-http-contrib": "/hub-http-contrib/static-1.2812",
  "interframe": "/interframe/static-3.4559",
  "tinymce-data": "/tinymce-data/static-1.39739",
  "tinymce-plugins": "/tinymce-plugins/static-1.56768",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4981",
  "magpie-lib": "/magpie-lib/static-1.5362",
  "magpie-types": "/magpie-types/static-1.4822",
  "simple-logging-lib": "/simple-logging-lib/static-1.2818",
  "content-assistance-lib": "/content-assistance-lib/static-1.7399",
  "dashboard-lib": "/dashboard-lib/static-1.80474",
  "ExportDialog": "/ExportDialog/static-6.10156",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17507",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17499",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8458",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8182",
  "feedback-loader": "/feedback-loader/static-1.28790",
  "onboarding-scopes": "/onboarding-scopes/static-1.6232",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4417",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.106",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4291",
  "nav-client-types": "/nav-client-types/static-1.2123",
  "purchase-motions-api": "/purchase-motions-api/static-1.5440",
  "trials-service-types": "/trials-service-types/static-1.3692",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.494",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16902",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12719",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5351",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7556",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10140",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31066",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10805",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6306",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.143",
  "customer-data-tracking": "/customer-data-tracking/static-1.6650",
  "products-iframe-lib": "/products-iframe-lib/static-1.7223",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9776",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8448",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3922",
  "video-components-external": "/video-components-external/static-1.10473",
  "video-data-lib": "/video-data-lib/static-1.34131",
  "directed-graph": "/directed-graph/static-1.705",
  "event-emitter": "/event-emitter/static-1.715",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5272",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9477",
  "fsm": "/fsm/static-1.3499",
  "policy-lib": "/policy-lib/static-1.6552",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9540",
  "navigation-messaging": "/navigation-messaging/static-1.6483",
  "FileManagerLib": "/FileManagerLib/static-1.38427",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8867",
  "FileManagerCore": "/FileManagerCore/static-1.38286",
  "codemirror": "/codemirror/static-5.90",
  "layout-dnd-components": "/layout-dnd-components/static-1.11973",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10948",
  "react-codemirror": "/react-codemirror/static-1.10394",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9657",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13697",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8463",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27853",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8336",
  "payment-link-components": "/payment-link-components/static-1.22839",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23859",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2973",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2763",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34920",
  "sales-views-client-types": "/sales-views-client-types/static-1.4059",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3422",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11329",
  "content-media-compositions": "/content-media-compositions/static-2.15336",
  "media-bridge-lib": "/media-bridge-lib/static-1.18512",
  "trellis-story-utils": "/trellis-story-utils/static-1.4291",
  "storybook-react": "/storybook-react/static-1.28",
  "audio-components": "/audio-components/static-1.5564",
  "FileManagerImages": "/FileManagerImages/static-1.35938",
  "video-components": "/video-components/static-1.12476",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4302",
  "video-embed": "/video-embed/static-1.34965",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67595",
  "layout-data-lib": "/layout-data-lib/static-1.9273",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6353",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5668",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4856",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3445",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21255",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3612",
  "hls.js": "/hls.js/static-1.34",
  "social-insights-client-types": "/social-insights-client-types/static-1.21258",
  "outpost": "/outpost/static-1.3975",
  "advanced-menus-core": "/advanced-menus-core/static-1.14768",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11750",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33336",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14767",
  "simple-menus-lib": "/simple-menus-lib/static-1.16284"
}
};
